import { handleGetWelcome } from '@/utils/Page/personalRecommend';
import { useEffect, useState } from 'react';
import MyIcon from '@/components/MyIcon';
import s from './welcome.module.scss';
const PersonalWelcome = (props) => {
    const { onSubmit } = props;
    let [welcome, setWelcome] = useState({});
    const init = async () => {
        let res = await handleGetWelcome();
        console.log(res);
        if (res) {
            setWelcome(res);
        }
    };
    useEffect(() => {
        init();
    }, []);
    const onClickRecommend = () => {
        onSubmit(welcome.guide_question);
    };
    return (
        <>
            {welcome.content && (
                <div className={s.welcomeWrap}>
                    <div className={s.welcomeContentWrap}>
                        <div className={s.welcomeContent}>{welcome.content}</div>
                        <div className={s.welcomeRecommend} onClick={onClickRecommend}>
                            帮我推荐相关学习内容
                            <MyIcon className={s.icon} type="icon-right" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default PersonalWelcome;
